import React, { useState } from "react";
import { FaCopy, FaCheck } from "react-icons/fa";

/**
 * Drop-in replacement for react-code-blocks CopyBlock.
 * Props: text, language (unused, kept for compat), theme (unused), wrapLines (unused)
 */
export function CopyBlock({ text }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="relative group rounded-lg overflow-hidden">
      <pre className="bg-[#282a36] text-[#f8f8f2] text-sm p-4 overflow-x-auto rounded-lg font-mono leading-relaxed whitespace-pre-wrap break-words">
        {text}
      </pre>
      <button
        onClick={handleCopy}
        className="absolute top-2 right-2 p-1.5 rounded-md bg-white/10 hover:bg-white/20 text-white/70 hover:text-white transition-colors opacity-0 group-hover:opacity-100"
        title="Copy to clipboard"
      >
        {copied ? <FaCheck size={12} /> : <FaCopy size={12} />}
      </button>
    </div>
  );
}

// Dummy theme export for compat — not used
export const dracula = {};
